import sportsApi from '../../utils/sportsApi';

const getAllPostsFromAPI = async (
    payload,
    clientId,
): Promise<{
    posts: any;
    engagementsTotal: number;
    videoViewsTotal: number;
    impressionsTotal: number;
    fmvTotal: number;
    postCount: number;
}> => {
    return await sportsApi
        .url(`/clients/${clientId}/owned-accounts/posts`)
        .json(payload)
        .post()
        .json();
};

export default getAllPostsFromAPI;
